export const initialState = {
  currentLocale: undefined
};

export type LocaleState = Readonly<typeof initialState>;
